var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reavealable-text"},[(_vm.value)?_vm._t("default"):_c('b-button',{attrs:{"type":"is-primary","icon-right":"sparkles"},on:{"click":_vm.reveal}},[_vm._v(_vm._s(_vm.title)+" aufdecken")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }